import React from "react";
import { Button } from "@mui/material";

// Hero component representing the hero section of a webpage
function Hero() {
  // Function to handle button click event
  const handleClick = () => {
    // Scroll the window to a specific position (1250 pixels from the top) with smooth animation
    window.scrollTo({ top: 1250, behavior: "smooth" });
  };

  return (
    // Main container with flex layout, wrapping content in two sections
    <div className="w-full flex flex-wrap">
      {/* Left section containing text content */}
      <div className="flex flex-col items-start justify-center md:p-40 p-10 md:w-1/2 w-full">
        {/* Title */}
        <h1 className="font-semibold text-red-600 text-3xl">Fitness Fusion</h1>
        {/* Slogan */}
        <h1 className="font-semibold text-black text-5xl my-3">
          Sweat, Shine, and Repeat
        </h1>
        {/* Button to explore exercises, triggers handleClick function on click */}
        <div className="my-10">
          <Button variant="outlined" color="error" onClick={handleClick}>
            Explore Exercises
          </Button>
        </div>
      </div>
      {/* Right section containing an image */}
      <div className="flex items-center justify-center md:w-1/2 w-full overflow-hidden p-1">
        {/* Image with source URL and alt text */}
        <img
          src="https://wallpapers.com/images/hd/hrithik-roshan-body-hooded-vest-iuyitvyodcx9i8of.jpg"
          alt="Fitness"
          className="mb-6 object-cover md:rounded-full rounded-lg shadow-2xl"
        />
      </div>
    </div>
  );
}

// Exporting the Hero component to use in other parts of the application
export default Hero;
